// context/LiveScoresContext.js
'use client'; // Ensure this component runs only on the client side

import { getEventSource, subscribeToLiveScores } from '@/services/EventSourceService';
import React, { createContext, useContext, useEffect, useState } from 'react';
import { liveScoreToday, liveOdds } from "@/config";

// Create a context to store the live scores
const LiveScoresContext = createContext();

// Custom hook to access the live scores from the context
export function useLiveScores() {
  return useContext(LiveScoresContext);
}

export function sortMatches(a, b) {
  const currentTime = Math.floor(Date.now() / 1000);
  // status 1 =>> first hafl
  if (a.status === '1' && b.status !== '1') return -1;
  if (a.status !== '1' && b.status === '1') return 1;
  // status 2 =>> hafl time
  if (a.status === '2' && b.status !== '2') return -1;
  if (a.status !== '2' && b.status === '2') return 1;
  // status 3 =>> second half
  if (a.status === '3' && b.status !== '3') return -1;
  if (a.status !== '3' && b.status === '3') return 1;
  
  // Kiểm tra matchTime là tương lai hay quá khứ
  const timeDiffA = a.matchTime - currentTime;
  const timeDiffB = b.matchTime - currentTime;

  // Ưu tiên matchTime trong tương lai (timeDiff >= 0) hơn quá khứ
  if (timeDiffA >= 0 && timeDiffB < 0) return -1;
  if (timeDiffA < 0 && timeDiffB >= 0) return 1;

  // Nếu cả hai đều ở tương lai hoặc đều ở quá khứ, ưu tiên thời gian gần hiện tại nhất
  return Math.abs(timeDiffA) - Math.abs(timeDiffB);
}

// Provider component that manages the live scores state
export function LiveScoresProvider({ children }) {
  const [dataLiveScoresToday, setDataLiveScoresToday] = useState({});
  const [dataLiveScores, setDataLiveScores] = useState({});
  const [dataLiveOdds, setDataLiveOdds] = useState({});

  useEffect(() => {
    setDataLiveScoresToday(prevData => {
      const data = {
        ...dataLiveScores,
        liveOdd: dataLiveOdds
      };

      const preChanges = {
        liveScoreToday: prevData?.liveScoreToday,
        liveScoreChanges: prevData?.liveScoreChanges,
        liveStats: prevData?.liveStats,
      }

      const nowChanges = {
        liveScoreToday: data.liveScoreToday,
        liveScoreChanges: data.liveScoreChanges,
        liveStats: data.liveStats,
      }

      const isChange = JSON.stringify(preChanges) !== JSON.stringify(nowChanges);

      return {
        isChange: isChange, 
        ...data
      }
    });
  }, [dataLiveOdds, dataLiveScores])

  useEffect(() => {
    // Initialize the EventSource and subscribe to updates
    getEventSource('liveScoreToday', liveScoreToday);
    const unsubscribeLiveScoreToday = subscribeToLiveScores('liveScoreToday', (data) => {
      setDataLiveScores(data);
    });
    // getEventSource('liveScoreChanges', liveScoreChanges);
    // const unsubscribeLiveScoreChanges = subscribeToLiveScores('liveScoreChanges', (data) => {
    //   setDataLiveScoreChanges(data)
    // })

    getEventSource('liveOdds', liveOdds);
    const unsubscribeLiveOdds = subscribeToLiveScores('liveOdds', (data) => {
      setDataLiveOdds(data);
    })

    // getEventSource('liveEvents', liveEvents);
    // const unsubscribeLiveEvents = subscribeToLiveScores('liveEvents', (data) => {
    //   setDataLiveEvents(data)
    // })

    // getEventSource('liveStats', liveStats);
    // const unsubscribeLiveStats = subscribeToLiveScores('liveStats', (data) => {
    //   setDataLiveStats(data)
    // })

    // Cleanup when the component unmounts
    return () => {
      unsubscribeLiveOdds();
      unsubscribeLiveScoreToday();
      // unsubscribeLiveScoreChanges();
      // unsubscribeLiveEvents();
      // unsubscribeLiveStats();
    };
  }, []);

  return (
    <LiveScoresContext.Provider value={dataLiveScoresToday}>
      {children}
    </LiveScoresContext.Provider>
  );
}
